import { ulid } from "@/schemas/commonFields";
import { z } from "@/zod";

const defaultStoreProjectAssignee = z.object({
  id: ulid,
  user_id: ulid,
  user_name: z.string(),
  user_role_code: z.string(),
  user_role_name: z.string(),
  store_id: ulid,
  store_name: z.string(),
  project_type_id: ulid,
  project_type_name: z.string(),
  is_primary: z.boolean(),
  updated_at: z.string().date(),
});

export const defaultStoreProjectAssigneeListItem = defaultStoreProjectAssignee
  .omit({
    user_role_code: true,
  })
  .readonly();

export const readDefaultStoreProjectAssignee =
  defaultStoreProjectAssignee.readonly();

export const defaultStoreProjectAssigneeCreate = z.object({
  project_type_ids: z.array(ulid),
  store_ids: z.array(ulid),
  is_primary: z.boolean(),
  user_id: ulid,
});

export const defaultStoreProjectAssigneeCreateForm = z.object({
  is_primary: z.boolean(),
  user_id: ulid,
  selectedSystemRoleCodes: z.array(z.string()).optional(),
});

export const defaultStoreProjectAssigneeCreateResponse =
  defaultStoreProjectAssigneeCreate.extend({
    id: ulid,
    updated_at: z.string().date(),
  });

export const defaultStoreProjectAssigneeUpdate = z.object({
  store_id: ulid,
  project_type_id: ulid,
  is_primary: z.boolean(),
  user_id: ulid,
  selectedSystemRoleCodes: z.array(z.string()).optional(),
});

export const defaultStoreProjectAssigneeUpdateResponse =
  defaultStoreProjectAssigneeListItem;
